const userName = (state = "", action) => {
    switch(action.type) {
        case 'userName':
            return action.payload;
        default:
            return state;
    }
}

export default userName;